import { AlertTriangle } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface CopilotDisclaimerProps {
  remainingMessages: number;
  gameRemainingMessages: number;
  isBalanceLoaded?: boolean;
}

export function CopilotDisclaimer({ remainingMessages, gameRemainingMessages, isBalanceLoaded = true }: CopilotDisclaimerProps) {
  return (
    <div className="border-t border-[hsl(var(--sg7-stroke-subtle))] pt-2 space-y-1">
      <div className="flex items-center gap-2 text-xs text-[hsl(var(--sg7-text-muted))]">
        <AlertTriangle className="h-3 w-3 shrink-0" />
        <span>Statistical guidance only. Not financial advice.</span>
      </div>
      <div className="flex items-center justify-between text-xs text-[hsl(var(--sg7-text-muted))]">
        {isBalanceLoaded ? (
          <>
            <span>{gameRemainingMessages} msgs left for this game</span>
            <span>{remainingMessages} msgs/hour</span>
          </>
        ) : (
          <>
            <Skeleton className="h-3 w-24 inline-block" />
            <Skeleton className="h-3 w-16 inline-block" />
          </>
        )}
      </div>
    </div>
  );
}
